import React, { useState } from 'react';
import { TicketIcon, CopyIcon, CheckIcon, ClockIcon, TagIcon } from 'lucide-react';
export function CouponsSection() {
  const [copiedCode, setCopiedCode] = useState<string | null>(null);
  const coupons = [{
    id: 1,
    code: 'WELCOME10',
    discount: '10% OFF',
    description: 'Welcome discount on your first order',
    minOrder: 100,
    expiryDate: '2024-12-31',
    status: 'active',
    used: false
  }, {
    id: 2,
    code: 'SAVE20',
    discount: 'SAR 20 OFF',
    description: 'Save SAR 20 on orders above SAR 200',
    minOrder: 200,
    expiryDate: '2024-11-30',
    status: 'active',
    used: false
  }, {
    id: 3,
    code: 'FREESHIP',
    discount: 'Free Shipping',
    description: 'Free delivery on all orders',
    minOrder: 0,
    expiryDate: '2024-10-31',
    status: 'expired',
    used: false
  }, {
    id: 4,
    code: 'SUMMER25',
    discount: '25% OFF',
    description: 'Summer special discount',
    minOrder: 150,
    expiryDate: '2024-09-30',
    status: 'used',
    used: true
  }];
  const handleCopyCode = (code: string) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(null), 2000);
  };
  const activeCoupons = coupons.filter(c => c.status === 'active');
  const usedCoupons = coupons.filter(c => c.status === 'used');
  const expiredCoupons = coupons.filter(c => c.status === 'expired');
  return <div className="space-y-6" data-id="element-449" data-mp="1hnuv8z6t5wk5">
      {/* Active Coupons */}
      {activeCoupons.length > 0 && <div data-id="element-450" data-mp="1mpk8mlhi6mbe">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-451" data-mp="1mosezg7guynr">
            Available Coupons
          </h3>
          <div className="space-y-4" data-id="element-452" data-mp="1rmkbyomyxayt">
            {activeCoupons.map(coupon => <div key={coupon.id} className="bg-white rounded-xl border-2 border-dashed border-green-500 p-4 relative overflow-hidden" data-id="element-453" data-mp="3oh6rfzr8raws">
                <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-454" data-mp="3lesh40x7wtj4">
                  ACTIVE
                </div>
                <div className="flex items-start gap-4" data-id="element-455" data-mp="3vcq5cof2uqbq">
                  <div className="flex-shrink-0 w-16 h-16 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-456" data-mp="3va3xeno9y8sz">
                    <TagIcon className="w-8 h-8 text-green-600" data-id="element-457" data-mp="87hbpwe517xg" />
                  </div>
                  <div className="flex-1" data-id="element-458" data-mp="854kstqejn89">
                    <div className="flex items-center gap-2 mb-2" data-id="element-459" data-mp="46p1aztj4wzl">
                      <h4 className="text-2xl font-bold text-green-600" data-id="element-460" data-mp="hxalcrupzcz2">
                        {coupon.discount}
                      </h4>
                    </div>
                    <p className="text-sm text-gray-700 mb-2" data-id="element-461" data-mp="cyzcajc916hw">
                      {coupon.description}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-gray-500 mb-3" data-id="element-462" data-mp="mwdizr8degx0">
                      <span data-id="element-463" data-mp="muka05aabklu">Min. order: SAR {coupon.minOrder}</span>
                      <span className="flex items-center gap-1" data-id="element-464" data-mp="16ioqno3lfk5c">
                        <ClockIcon className="w-3 h-3" data-id="element-465" data-mp="1ak1zm71zg3gh" />
                        Expires: {coupon.expiryDate}
                      </span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-466" data-mp="wmdc0rgj6i7q">
                      <div className="flex-1 bg-gray-100 rounded-lg px-4 py-2 font-mono font-bold text-gray-900 border-2 border-dashed border-gray-300" data-id="element-467" data-mp="11hsszs9u4u8d">
                        {coupon.code}
                      </div>
                      <button onClick={() => handleCopyCode(coupon.code)} className="px-4 py-2 bg-[#1E2B55] text-white rounded-lg hover:bg-[#162041] transition-colors flex items-center gap-2 font-semibold" data-id="element-468" data-mp="rm7l5di34zqp">
                        {copiedCode === coupon.code ? <>
                            <CheckIcon className="w-4 h-4" data-id="element-469" data-mp="8tdfja6cqjz5" />
                            Copied
                          </> : <>
                            <CopyIcon className="w-4 h-4" data-id="element-470" data-mp="175zgkxhyk9c5" />
                            Copy
                          </>}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>}
      {/* Used Coupons */}
      {usedCoupons.length > 0 && <div data-id="element-471" data-mp="ofzv0klbtcdh">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-472" data-mp="of86tuu26gx8">Used Coupons</h3>
          <div className="space-y-4" data-id="element-473" data-mp="jgn51qz5rp6o">
            {usedCoupons.map(coupon => <div key={coupon.id} className="bg-gray-50 rounded-xl border border-gray-200 p-4 opacity-60" data-id="element-474" data-mp="jihthf9n1zfi">
                <div className="flex items-start gap-4" data-id="element-475" data-mp="2dtd38kwk7kjv">
                  <div className="flex-shrink-0 w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-476" data-mp="28vur6ln8wp7n">
                    <CheckIcon className="w-8 h-8 text-gray-500" data-id="element-477" data-mp="2gfngxr5r748m" />
                  </div>
                  <div className="flex-1" data-id="element-478" data-mp="2ldxda537savt">
                    <div className="flex items-center gap-2 mb-2" data-id="element-479" data-mp="2lcme6ikprrb1">
                      <h4 className="text-xl font-bold text-gray-600" data-id="element-480" data-mp="2q4njfkjgshrk">
                        {coupon.discount}
                      </h4>
                      <span className="text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded-full font-semibold" data-id="element-481" data-mp="2v38kfm6jj5h2">
                        USED
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-482" data-mp="22fl5onryb92c">
                      {coupon.description}
                    </p>
                    <div className="font-mono font-bold text-gray-500" data-id="element-483" data-mp="2cdisd6u5wxsu">
                      {coupon.code}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>}
      {/* Expired Coupons */}
      {expiredCoupons.length > 0 && <div data-id="element-484" data-mp="1nq6bp5ag26n2">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-485" data-mp="1npn0e7faugi0">
            Expired Coupons
          </h3>
          <div className="space-y-4" data-id="element-486" data-mp="1iqa4kx6g9z3a">
            {expiredCoupons.map(coupon => <div key={coupon.id} className="bg-gray-50 rounded-xl border border-gray-200 p-4 opacity-50" data-id="element-487" data-mp="1wre6hddr4pce">
                <div className="flex items-start gap-4" data-id="element-488" data-mp="1sneqqx0apuk3">
                  <div className="flex-shrink-0 w-16 h-16 bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-489" data-mp="150zxnvkli37l">
                    <ClockIcon className="w-8 h-8 text-gray-500" data-id="element-490" data-mp="102eylzh2xpkq" />
                  </div>
                  <div className="flex-1" data-id="element-491" data-mp="1dt1uzkzdb3dn">
                    <div className="flex items-center gap-2 mb-2" data-id="element-492" data-mp="191jusz5656tq">
                      <h4 className="text-xl font-bold text-gray-600" data-id="element-493" data-mp="18zyx50nk57rn">
                        {coupon.discount}
                      </h4>
                      <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded-full font-semibold" data-id="element-494" data-mp="ham3nzig9uad">
                        EXPIRED
                      </span>
                    </div>
                    <p className="text-sm text-gray-600 mb-2" data-id="element-495" data-mp="bx5lidlwyza4">
                      {coupon.description}
                    </p>
                    <div className="font-mono font-bold text-gray-500" data-id="element-496" data-mp="3tef48cwwp6kb">
                      {coupon.code}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>}
      {/* Empty State */}
      {activeCoupons.length === 0 && usedCoupons.length === 0 && expiredCoupons.length === 0 && <div className="text-center py-12" data-id="element-497" data-mp="fz921gnfwu29">
            <TicketIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-498" data-mp="fyhg6xjnaap6" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-499" data-mp="kwiw59lrxtwf">
              No Coupons Available
            </h3>
            <p className="text-gray-500 mb-6" data-id="element-500" data-mp="30nn9ljvhopz3">
              Check back later for exclusive deals and discounts
            </p>
          </div>}
    </div>;
}